var app = app ||  {};
app.fornecedor = app.fornecedor || {};

;(function(namespace, $){

  var Fornecedor = function() {

    function CadastraFornecedor() {
      var validate_form = new lcssafira.form.ValidateForm('form-fornecedor');
    }

    function BuscaFornecedor() {
      $('#form-busca-forn').submit(function(event) {
        event.preventDefault();
        var data = $(this).serialize();
        app.datatable.initDataTable(true, false, '?' + data, 'fornecedor', '/fornecedor/consultar');
      });
    }
    
    function abreFornecedor() {
      $('table').on('click', '.fornecedor-col', function(event) {
        event.preventDefault();
        id_fornecedor = $(this).parents('tr').find('.cod').text();
        app.ajaxrequest.initialize('/fornecedor/consultar/' + id_fornecedor, 'get', 'json', '', app.fornecedor.responseFornecedor);
      });
    }

    function responseFornecedor(data) {
      var holder_contatos;

      holder_contatos = $('#holder-contatos');
      holder_contatos.html('');

      $('.bd-holder').each(function(index, el) {
        column = $(this).attr('data-column');

        if(data[0][column] == '' || data[0][column] == null)
          $(el).text('n/d');
        else
          $(el).html(data[0][column]);
      });

      $.each(data[0]['contato_fornecedor'], function(index, val) {

        if(val.tel_contato_fornecedor != '' || val.tel_contato_fornecedor != 'n/d')
          tel_fornecedor = app.main.formatTel(val.tel_contato_fornecedor);
        else
          tel_fornecedor = 'n/d';

        if(val.cel_contato_fornecedor != '' || val.cel_contato_fornecedor != 'n/d')
          cel_fornecedor = app.main.formatTel(val.cel_contato_fornecedor);
        else
          cel_fornecedor = 'n/d';


         holder_contatos.append(
          '<span class="block small">Contato: ' + val.nome_contato_fornecedor + '</span>' + 
          '<span class="block small">Tel.: ' + tel_fornecedor + '</span>' +
          '<span class="block small">Cel.: ' + cel_fornecedor + '</span>' +
          '<span class="block small">E-mail: ' + val.email_contato_fornecedor + '</span>'
          );
      });

      $('#modal-fornecedor').modal();
    }

    function _construct() {
      CadastraFornecedor();
      BuscaFornecedor();
      abreFornecedor();

      app.datatable.initDataTable(false, true, '', 'fornecedor', '/fornecedor/consultar');
      var message = "A remoção de um fornecedor implica na exclusão de qualquer dado vinculado a ele.";
      var confirm_modal = new lcssafira.confirmmodal.ConfirmModal('.remove-fornecedor', message);
    }

    namespace.responseFornecedor = responseFornecedor;
    _construct();

  };

  var main = new Fornecedor();

})(app.fornecedor, jQuery);


